import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DataValueMap } from 'Helpers/Testing';


const useStyles = buildUseStyles('EstatePlanningProfileSubpageFooterImage', (theme) => ({
  img: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
    borderRadius: theme.spacing(2),
  },
}));

const EstatePlanningProfileSubpageFooterImage = ({
  imageURL,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <img
      src={imageURL}
      className={classes.img}
      alt={'Wealth.com Logo'}
      {...DataValueMap
        .init('estate-planning-page-footer-image')
        .build()}
    />
  );
};

EstatePlanningProfileSubpageFooterImage.propTypes = {
  imageURL: PropTypes.string.isRequired,
};

export default EstatePlanningProfileSubpageFooterImage;
